<template>
  <div class="bg-white  gray3 radius20">
    <template v-if="type == 'goods'">
      <div class="flex items-center">
        <img class="wh100 flex-shrink radius10" :src="`${data.picUrl}?imagediv2/1/w/100/h/100`" />
        <div class="flex mar20-l flex-auto flex-column">
          <div class="black f28 fb ellipsis-2">
            {{ data.name }}
          </div>
          <div class="gray9 f24 mar6-t">{{ data.skuSpecsIndex }}</div>
        </div>
      </div>
      <div class="flex items-center pad30-tb pad28-r border-b">
        <div class="w208 black f28 mar10-t lh28 fb">货品评价</div>
        <div class="flex-auto">
          <van-rate :value="data.goodsExponent" readonly />
        </div>
        <div class="text-center gray-b f26 w80">{{ rateText(data.goodsExponent) }}</div>
      </div>
    </template>
    <div v-if="type == 'user'" class="flex items-center">
      <img class="wh68 flex-shrink radius100" :src="`${data.buyerImg}?imagediv2/1/w/68/h/68`" />
      <div class="flex flex-auto mar20-l flex-auto flex-column">
        <div class="flex black items-center gray3 f28 fb">
          <div class="ellipsis mar10-r">{{ data.buyerNameEnc }}</div>
          <img
            v-if="data.buyerType == 1"
            src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png"
            mode="widthFix"
            class="w48 mar2-b h28 flex-shrink"
          />
          <img
            v-if="data.buyerType == 2"
            src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png"
            mode="widthFix"
            class="wh28 flex-shrink mar2-b"
          />
          <img
            v-if="data.buyerType == 3"
            src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png"
            mode="widthFix"
            class="wh28 flex-shrink mar2-b"
          />
          <img
            v-if="data.buyerType == 4"
            src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png"
            mode="widthFix"
            class="wh28 flex-shrink mar2-b"
          />
          <img
            v-if="data.buyerType == 5"
            src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png"
            mode="widthFix"
            class="wh28 flex-shrink mar2-b"
          />
          <div class="flex-auto"></div>
          <van-rate class="flex-shrink mar2-t" :size="15" :value="data.goodsExponent" readonly />
        </div>
        <div class="gray9 f24 mar4-t" v-if="data.skuSpecsIndex">{{ data.skuSpecsIndex }}</div>
      </div>
    </div>
    <template v-if="data.evaluateSkuData">
      <div
        class="f28"
        :class="{
          'mar20-t': type == 'goods',
          'mar10-t': type != 'goods',
          'ellipsis-2': ellipsis
        }"
      >
        {{ data.evaluateSkuData.cmtBody }}
      </div>
      <div
        v-if="data.evaluateSkuData.imgList && data.evaluateSkuData.imgList.length"
        class="flex justify-between flex-wrap mar10-tb items-center"
      >
        <div
          v-for="(item, index) in data.evaluateSkuData.imgList"
          class="relative mar12-b wh210"
          @click="goDetail(`/comment/detail/detail?id=${data.evaluateSkuData.id}&index=${index}`)"
          :key="index"
        >
          <img
            class="wh210 radius10"
            :src="
              isVideo(item)
                ? `${item}?vframe/png/offset/1/w/226/h/226/imageMogr2/thumbnail/80000@`
                : `${item}?imagediv2/1/w/210/h/210`
            "
          />
          <img
            v-if="isVideo(item)"
            class="absolute video"
            src="https://nfs.nxin.com/cms_image_c34fcdac-7f89-454c-950c-3eb84a87c497.png?imagediv2/1/w/80/h/80"
          />
        </div>
        <div class="w210"></div>
        <div class="w210"></div>
      </div>
      <div class="arial f26 gray-97" :class="{ 'ellipsis-2': ellipsis }">
        {{ data.evaluateSkuData.cmtDate }}
      </div>
      <div
        v-if="data.evaluateSkuData.sellerReplyList && data.evaluateSkuData.sellerReplyList.length"
      >
        <div class="mar20-t pad20-lr pad10-t pad14-b radius8 bg-f5">
          <div v-for="(item, index) in data.evaluateSkuData.sellerReplyList" :key="index">
            <div class="gray3 f28 mar8-b fb" :class="{ 'mar10-t': index }">卖家回复：</div>
            <div class="f28 gray6" :class="{ 'ellipsis-2': ellipsis }">
              {{ item.cmtBody }}
            </div>
            <div class="f26 gray-97 mar2-t arial">{{ item.cmtDate }}</div>
          </div>
        </div>
      </div>
      <template v-if="data.evaluateSkuData.replyList && data.evaluateSkuData.replyList.length">
        <div class="border-b mar20-t mar16-b">
          <div class="relative arrow"></div>
        </div>
        <div v-for="(item, index) in data.evaluateSkuData.replyList" :key="index">
          <div class="fb f28 yellow" :class="{ 'mar14-t': index }">追评</div>
          <div class="mar10-b gray3" :class="{ 'ellipsis-2': ellipsis }">{{ item.cmtBody }}</div>
          <div
            v-if="item.imgList && item.imgList.length"
            class="flex justify-between flex-wrap mar10-tb items-center"
          >
            <div
              v-for="(item2, index) in item.imgList"
              class="relative mar12-b wh210"
              :key="index"
              @click="
                goDetail(
                  `/comment/detail/detail?id=${data.evaluateSkuData.id}&replyId=${
                    item.id
                  }&index=${index}`
                )
              "
            >
              <img
                class="wh210 radius10"
                :src="
                  isVideo(item2)
                    ? `${item2}?vframe/png/offset/1/w/226/h/226/imageMogr2/thumbnail/80000@`
                    : `${item2}?imagediv2/1/w/210/h/210`
                "
              />
              <img
                v-if="isVideo(item2)"
                class="absolute video"
                src="https://nfs.nxin.com/cms_image_c34fcdac-7f89-454c-950c-3eb84a87c497.png?imagediv2/1/w/80/h/80"
              />
            </div>
            <div class="w210"></div>
            <div class="w210"></div>
          </div>
          <div
            class="arial f26 gray-97"
            :class="{ 'mar16-t': item.imgList && item.imgList.length }"
          >
            {{ item.cmtDate }}
          </div>
        </div>
      </template>
      <div v-if="replyBtn" class="flex justify-end">
        <a
          :href="
            `${VUE_APP_SC}vm2/comment/add/add2?orderId=${data.evaluateSkuData.orderId}&goodsId=${
              data.goodsId
            }&commentId=${data.evaluateSkuData.id}`
          "
          hover-class="none"
          class="btn radius16 white fb f28 text-center"
          >追评</a
        >
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { isVideo, rateText } from "@/utils/utils";

export default {
  data() {
    return {
      isVideo,
      rateText,
      VUE_APP_SC: process.env.VUE_APP_SC
    };
  },
  props: {
    type: {
      type: String,
      default: "goods"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    replyBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goDetail(url) {
      window.open(`${this.VUE_APP_SC}vm2${url}`);
    }
  }
};
</script>
